module.exports = __webpack_public_path__ + "static/cad-designs25-6e658512f2d77a253e1704b46126a769.png";